export default __webpack_public_path__ + "static/media/loding.21221623.gif";